import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const useAuth = () => {
   const user = false;
   return user;
};

export const ProtectedRoutes = () => {
   const isAuth = useAuth();
   return isAuth ? <Outlet /> : <Navigate to="/" replace />;
};
